/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import $ from 'jquery';

( function() {

    if($('.js-swither').length){
        $(document).on('change', '.js-swither', function (){
            if( $(this).is(":checked") ){
                $('.js-month-prices').hide();
                $('.js-annual-prices').show();
                $('.swither').removeClass('ismonth');
                $('.js-discount').show();
            }else{
                $('.js-month-prices').show();
                $('.js-annual-prices').hide();
                $('.swither').addClass('ismonth');
                $('.js-discount').hide();
            }
        });
    }

} )();